import React from 'react';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { useCategoryControlCenter } from '../../../Hooks/Features/ControlCentre/useCategoryControlCenter';
import { SkeletonDataTable } from '../../../components/Loader/Loader';

function CategoryWiseControlCenter() {
    const { category, innerColumns, treeData, assignGridBodyTemplate, assignGridTemplate, loader ,expandedKeys,setExpandedKeys} = useCategoryControlCenter()

    const headerGroup = (
        <ColumnGroup>
            <Row>
                <Column header="Resource Name" rowSpan={3} style={{ width: "14%" }} className='ccc-resource-column cc-main-header'/>
                <Column header="Parent Resource Name" rowSpan={3} style={{ width: "10%" }} />
            </Row>
            <Row>
                {
                    category.map((value, index) => {
                        return (<Column key={index} header={value?.user_category_name} colSpan={2} />
                        )
                    })
                }
            </Row>
            <Row>
                {
                    innerColumns.map((value, index) => {
                        return <Column key={index} header={value?.name} />
                    })
                }
            </Row>
        </ColumnGroup>
    );
    return (
        <div>
            <div className='row mx-0'>
                <div className="col-md-6">
                    <h5>Category Control Center</h5>
                </div>
            </div>

            {
                loader ? <SkeletonDataTable numSkeletons={15} /> : <TreeTable value={treeData} headerColumnGroup={headerGroup} tableStyle={{ width:"max-content" }}  className="cp-treetable"   expandedKeys={expandedKeys}
                    onToggle={(e) => setExpandedKeys(e.value)}>
                    <Column field="resource_name" expander className='ccc-resource-column'/>
                    <Column field="resource_key" />
                    {
                        innerColumns.map((value, index) => {
                            if (value?.name === "View") {
                                return <Column key={index} field="display" header="View" body={(e) => assignGridTemplate(e, value?.user_category_name)} className='view-border' />
                            } else {
                                return <Column key={index} field="edit" header="Editable" body={(e) => assignGridBodyTemplate(e, value?.user_category_name)} className='edit-border' />
                            }
                        })
                    }
                </TreeTable>
            }

        </div>
    )
}

export default CategoryWiseControlCenter;
